import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconPlus({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill={color} fillRule='nonzero'>
                <path d='M9 1a1 1 0 1 1 2 0v18a1 1 0 0 1-2 0V1z' />
                <path d='M1 11a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1z' />
            </g>
        </svg>
    );
}
